import React from 'react';
import Icon from '../app_components/Icon';
import { usesDashFormVariant } from '../../utils/formVariant';
import { iconColorForTone } from './morphismIconColors';

class SettingsLongTextInput extends React.Component {
  renderGameyField() {
    const {
      label,
      attribute,
      value,
      onChange,
      placeholder,
      tone = 'coral',
      hint,
      rows = 5,
    } = this.props;

    return (
      <div className={`lex-dash-field lex-dash-field--${tone}`}>
        {label && <label className="lex-dash-field__label">{label}</label>}
        <textarea
          className="lex-dash-field__textarea"
          rows={rows}
          onChange={(event) => onChange(event.target.value, attribute)}
          value={value || ''}
          placeholder={placeholder}
        />
        {hint && <p className="lex-dash-field__hint">{hint}</p>}
      </div>
    );
  }

  render() {
    const {
      label,
      attribute,
      value,
      onChange,
      placeholder,
      icon = 'file-alt',
      tone = 'grey',
      hint,
      rows = 8,
      variant,
    } = this.props;

    if (usesDashFormVariant(variant)) {
      return this.renderGameyField();
    }

    return (
      <div className="lex-field">
        {label && <p className="lex-field__label">{label}</p>}
        {hint && <p className="lex-field__hint">{hint}</p>}
        <div className={`lex-input lex-input--${tone} lex-input--textarea`}>
          <span className="lex-input__icon" aria-hidden="true">
            <Icon name={icon} size={18} color={iconColorForTone(tone)} />
          </span>
          <textarea
            className="lex-input__control"
            rows={rows}
            onChange={(event) => onChange(event.target.value, attribute)}
            value={value || ''}
            placeholder={placeholder}
          />
        </div>
      </div>
    );
  }
}

export default SettingsLongTextInput;
